import {AnyFunction} from './essentials'

export class MemoizeOne<T extends AnyFunction> {
  private params: Parameters<T> | undefined
  private result: ReturnType<T> | undefined

  isMemoized(params: Parameters<T>): boolean {
    const memoParams = this.params
    if (!memoParams) {
      return false
    }
    return params.every((arg, i) => arg === memoParams[i])
  }

  getMemoized(): ReturnType<T> {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore // check `isMemoized` before calling `getMemoized`
    return this.result
  }

  memoize(params: Parameters<T>, result: ReturnType<T>): void {
    this.params = params
    this.result = result
  }

  clear(): void {
    this.params = undefined
    this.result = undefined
  }
}
